import { makeActionCreator } from '../../utils/redux'

export const SUPPLIER_FETCHED = 'SUPPLIER_FETCHED'
export const supplierFetched = makeActionCreator(
  SUPPLIER_FETCHED,
  'supplier',
  'error'
)
